// Отероет письма откуда угодно если импортировать и вызвать метод из этого миксина
export const openEmailTrackingSidebar = {
  methods: {
    openEmailTrackingSidebar(id) {
      if (id && !this.$route.query.hasOwnProperty('email-tracking')) {
        this.$router.push({
          query: {
            ...this.$route.query,
            'email-tracking': id
          }
        });
        setTimeout(() => {
          this.$root.$emit('bv::toggle::collapse', 'sidebar-right-email-tracking');
        }, 0)
      }
    },
  }
}